import { HStack, RadioGroup } from "@chakra-ui/react";
import { SelectOption } from "./utils";

export const RadioOptions = ({ options }: { options: SelectOption }) => {
  return (
    <HStack flexWrap={"wrap"}>
      {options.map((item) => (
        <RadioGroup.Item key={item.value} value={item.value}>
          <RadioGroup.ItemHiddenInput />
          <RadioGroup.ItemIndicator />
          <RadioGroup.ItemText fontWeight={"normal"} fontSize={"xs"}>
            {item.label}
          </RadioGroup.ItemText>
        </RadioGroup.Item>
      ))}
    </HStack>
  );
};
